module.exports = __webpack_public_path__ + "static/img/6153_phase_function_Paper_Points.78ffa07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6153_phase_function_Paper_Points.png
// module id = QWOB
// module chunks = 0